import styled from 'styled-components';

import modernist from '../modernistTheme';

export const SectionHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 10px;
  border-bottom: 2px solid ${modernist.text};
`;

export const SectionLabel = styled.span`
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
`;

export const SectionTag = styled.span`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${modernist.neutral600};
`;

export const FieldButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: transparent;
  border: 0;
  border-bottom: 1px solid ${modernist.neutral400};
  padding: 14px 0;
  text-align: left;
  font-family: ${modernist.fontBody};
  font-size: 16px;
  font-weight: 600;
  color: ${modernist.text};
  cursor: pointer;

  &:hover {
    border-bottom-color: ${modernist.accent};
  }
`;

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px 6px 12px;
  background: ${modernist.accentLight};
  color: ${modernist.accentDark};
  font-size: 13px;
  font-weight: 700;
`;

export const ChipRemove = styled.button`
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  padding: 0;
  color: inherit;
  cursor: pointer;
`;

export const PopoverSearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-bottom: 2px solid ${modernist.text};
`;

export const PopoverSearchInput = styled.input`
  flex: 1;
  min-width: 0;
  appearance: none;
  background: transparent;
  border: 0;
  outline: none;
  font-family: ${modernist.fontBody};
  font-size: 15px;
  color: ${modernist.text};
  padding: 4px 0;
`;

export const PopoverList = styled.div`
  max-height: 244px;
  overflow-y: auto;
`;

export const PopoverEmpty = styled.div`
  padding: 18px 14px;
  font-size: 13px;
  color: ${modernist.neutral600};
`;

export const PopoverRow = styled.button`
  width: 100%;
  display: grid;
  grid-template-columns: 32px 1fr 20px;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  background: ${(props) => (props.$selected ? modernist.accentLight : 'transparent')};
  border: 0;
  border-bottom: 1px solid ${modernist.neutral300};
  text-align: left;
  cursor: pointer;
  font-family: ${modernist.fontBody};
  color: ${modernist.text};
`;

export const RowName = styled.span`
  display: block;
  font-size: 14px;
  font-weight: 700;
  min-width: 0;
`;

export const RowMeta = styled.span`
  display: block;
  font-size: 12px;
  color: ${modernist.neutral600};
`;

export const Avatar32 = styled.span`
  width: 32px;
  height: 32px;
  flex: none;
  display: grid;
  place-items: center;
  background: ${(props) =>
    props.$src
      ? `url(${props.$src}) center/cover no-repeat`
      : props.$selected
        ? modernist.accent
        : modernist.neutral300};
  color: ${(props) => (props.$selected ? '#fff' : modernist.neutral800)};
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
`;

export const CheckBox = styled.span`
  width: 20px;
  height: 20px;
  display: grid;
  place-items: center;
  border: 2px solid ${(props) => (props.$selected ? modernist.accent : modernist.neutral500)};
  background: ${(props) => (props.$selected ? modernist.accent : 'transparent')};
  color: #fff;
`;

export const Textarea = styled.textarea`
  width: 100%;
  box-sizing: border-box;
  margin-top: 12px;
  appearance: none;
  background: transparent;
  border: 2px solid ${modernist.neutral400};
  outline: none;
  padding: 12px;
  font-family: ${modernist.fontBody};
  font-size: 15px;
  line-height: 1.5;
  color: ${modernist.text};
  resize: vertical;

  &:focus {
    border-color: ${modernist.accent};
  }
`;

export const FooterBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 18px 32px;
  border-top: 2px solid ${modernist.text};
`;

export const ReadyLabel = styled.div`
  font-size: 12px;
  color: ${modernist.neutral700};
`;

export const BtnGhost = styled.button`
  appearance: none;
  background: transparent;
  border: 0;
  padding: 10px 18px;
  font-family: ${modernist.fontHeading};
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${modernist.neutral700};
  cursor: pointer;

  &:hover {
    color: ${modernist.text};
  }
`;

export const BtnPrimary = styled.button`
  appearance: none;
  background: ${(props) => (props.disabled ? modernist.neutral400 : modernist.accent)};
  border: 2px solid ${(props) => (props.disabled ? modernist.neutral400 : modernist.accent)};
  padding: 10px 24px;
  font-family: ${modernist.fontHeading};
  font-weight: 800;
  font-size: 13px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fff;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  min-width: 148px;
  white-space: nowrap;
`;
